import { authenticated } from '../../helpers/auth-header';
import insighttAPI from '../clients/insightt-api-client';
import { goalsEndpoints } from '../endpoints';

const createClientGoalForBonus = (clientId, payload) =>
  authenticated(insighttAPI).post(goalsEndpoints.createClientGoalForBonusAPI(clientId), payload);

const updateClientGoalForBonus = (clientId, goalId, payload) =>
  authenticated(insighttAPI).post(goalsEndpoints.updateClientGoalForBonusAPI(clientId, goalId), payload);

const getMTDYTDClientRRGoals = (clientId, timezoneOffset) =>
  authenticated(insighttAPI).get(goalsEndpoints.getMTDYTDClientRRGoalsAPI(clientId, timezoneOffset));

export const goalsService = {
  createClientGoalForBonus,
  updateClientGoalForBonus,
  getMTDYTDClientRRGoals,
};
